import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next'; // i18next hook'unu ekledik
import "./contactpage.css";
import { IoLocationOutline, IoMailOutline } from 'react-icons/io5';
import emailjs from 'emailjs-com';

const ContactPage = () => {
  const { t } = useTranslation(); // Çeviri fonksiyonunu başlattık
  const formRef = useRef();
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    });
  });

  useEffect(() => {
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  const [sending, setSending] = useState(false);
  const [resultMsg, setResultMsg] = useState("");

  const handleSubmit = (e) => {
    console.log("SERVICE:", process.env.REACT_APP_EMAILJS_SERVICE_ID);
    console.log("TEMPLATE:", process.env.REACT_APP_EMAILJS_TEMPLATE_ID);
    console.log("USERID:", process.env.REACT_APP_EMAILJS_USER_ID);

    e.preventDefault();
    setSending(true);

    emailjs.sendForm(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      formRef.current,
      process.env.REACT_APP_EMAILJS_USER_ID
    )
      .then(() => {
        setResultMsg(t('contactPage.messages.success'));
        setSending(false);
        formRef.current.reset();
      })
      .catch((err) => {
        console.error("EmailJS error:", err);
        setResultMsg(t('contactPage.messages.error'));
        setSending(false);
      });
  };

  return (
    <div className='contact-main-container'>
      <div className={`contact-card-container  ${isVisible ? 'fade-in' : ''}`} ref={ref}>

        <div className="contact-info">
          <h2 className='homepage-title2'>{t('contactPage.title')}</h2>
          <p className='homepage-text2 mb-4'>{t('contactPage.desc1')}</p>
          <p className='homepage-text2'>{t('contactPage.desc2')}</p>
          <div className='flex gap-4 items-center mb-4'>
            <div className='contact-icon'><IoMailOutline /> </div>
            <a href="mailto:info@thminvestment.com" target='_blank' rel="noreferrer" className='homepage-text2 mb-0 transition duration-300 hover:text-[#D56B21]'>info@thminvestment.com</a>
          </div>
          <div className='flex gap-4 items-center'>
            <div className='contact-icon'><IoLocationOutline /> </div>
            <p className='homepage-text2 mb-0'>{t('contactPage.address')}</p>
          </div>
        </div>

        <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>
          <div className='grid grid-cols-2 gap-4'>
            <div className="form-group">
              <label htmlFor="name">{t('contactPage.form.nameLabel')}</label>
              <input type="text" id="name" name="name" placeholder={t('contactPage.form.namePlaceholder')} required />
            </div>
            <div className="form-group">
              <label htmlFor="company">{t('contactPage.form.companyLabel')}</label>
              <input type="text" id="company" name="company" placeholder={t('contactPage.form.companyPlaceholder')} required />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="email">{t('contactPage.form.emailLabel')}</label>
            <input type="email" id="email" name="email" placeholder={t('contactPage.form.emailPlaceholder')} required />
          </div>
          <div className="form-group">
            <label htmlFor="investment-interest">{t('contactPage.form.investmentLabel')}</label>
            <input type="text" id="investment-interest" name="investment-interest" placeholder={t('contactPage.form.investmentPlaceholder')} required />
          </div>
          <div className="form-group">
            <label htmlFor="message">{t('contactPage.form.messageLabel')}</label>
            <textarea id="message" name="message" rows="5" placeholder={t('contactPage.form.messagePlaceholder')} required></textarea>
          </div>

          <button type="submit" className="homepage-link1 w-max" disabled={sending}>
            {sending ? t('contactPage.form.sendingBtn') : t('contactPage.form.sendBtn')}
          </button>
          {resultMsg && <p className="mt-2">{resultMsg}</p>}
        </form>
      </div>
    </div>
  );
};

export default ContactPage;